import PropTypes from 'prop-types';

function StarRating({ count = 5, fillColor = 'var(--hpn-color-green-500)' }) {
  const starPath =
    'M16.2461 9.54883H26.2861L18.1631 15.4502L21.2666 25L13.1436 19.0977L5.02051 25L8.12305 15.4502L0 9.54883H10.041L13.1436 0L16.2461 9.54883Z';
  const starWidth = 26.286;
  const gap = 6.289;
  const totalWidth = count * starWidth + (count - 1) * gap;

  return (
    <svg
      width={totalWidth}
      height="25"
      viewBox={`0 0 ${totalWidth} 25`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {Array.from({ length: count }).map((_, i) => {
        const key = `star-${i}`;
        return (
          <path
            key={key}
            d={starPath}
            fill={fillColor}
            transform={`translate(${i * (starWidth + gap)}, 0)`}
          />
        );
      })}
    </svg>
  );
}

StarRating.propTypes = {
  count: PropTypes.number,
  fillColor: PropTypes.string,
};

export default StarRating;
